<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">

    <div
        class="absolute inset-0 z-10 overflow-hidden bg-zinc-200/40 dark:bg-zinc-900/60 backdrop-blur-md flex items-center justify-center">

        <button type="button" (click)="closeBrandModal()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>

        <div class="relative w-[90%] h-[90%] primary-card-container flex flex-col overflow-hidden p-2 gap-y-2">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <div class="z-10 overflow-hidden h-full flex flex-col gap-y-2 px-2">
                <div class="shrink-0 z-10 w-full flex flex-row gap-x-4 p-2 justify-between card-container-pale">
                    <div class="w-full flex flex-wrap items-center justify-between sm:flex-nowrap">

                        <div class="flex items-center">
                            <div
                                class="shrink-0 size-12 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path d="M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5" />
                                    <path
                                        d="M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244" />
                                    <path d="M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05" />
                                </svg>
                            </div>
                            <div class="ml-4">
                                <h3 class="text-sm font-semibold text-primary">New brand</h3>
                                <p class="text-xs text-secondary">
                                    Add a brand to your roster.
                                </p>
                            </div>
                        </div>

                        <div class="flex shrink-0 flex flex-row items-center justify-end gap-x-4">
                            <!-- <nav aria-label="Tabs" class="flex space-x-2">
                                <a (click)="selectedTab.set('manual')"
                                    class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                    [class]="getTabClass('manual')">Manual</a>
                                <a (click)="selectedTab.set('smart')"
                                    class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                    [class]="getTabClass('smart')">Smart</a>
                            </nav> -->
                        </div>
                    </div>
                </div>

                <div class="flex-1 overflow-hidden flex flex-col items-center justify-start">
                    @if (selectedTab() === 'manual') {
                    <div
                        class="grid grid-cols-1 gap-x-6 gap-y-5 sm:gap-y-6 sm:grid-cols-6 w-full max-w-4xl py-6 overflow-y-auto scrollbar-transparent">

                        <div class="sm:col-span-6">
                            <span id="brand-logo-heading" class="block text-sm/6 font-medium text-primary">Brand
                                logo</span>
                            <div class="mt-2">
                                <atom-add-image [initialImage]="brandFormModel().brandLogo || undefined"
                                    [bucket]="S3BucketEnum.PRODUCT_IMAGES" variant="banner"
                                    fileInputId="agency-brand-logo-upload"
                                    (imageUploaded)="onBrandLogoUploaded($event)" />
                            </div>
                        </div>

                        <div class="sm:col-span-6">
                            <label for="agencyNameInput" class="block text-sm/6 font-medium text-primary">Brand
                                name</label>
                            <div class="mt-2 grid grid-cols-1">
                                <input #brandNameInput [formField]="brandForm.brandName" id="brandNameInput" type="text"
                                    placeholder="Brand name"
                                    class="col-start-1 row-start-1 block input-icon text-primary text-base min-h-11" />
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 dark:text-gray-400 sm:size-4">
                                    <path d="M10 5V3" />
                                    <path d="M14 5V3" />
                                    <path d="M15 21v-3a3 3 0 0 0-6 0v3" />
                                    <path d="M18 3v8" />
                                    <path d="M18 5H6" />
                                    <path d="M22 11H2" />
                                    <path d="M22 9v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9" />
                                    <path d="M6 3v8" />
                                </svg>

                            </div>
                            @if (brandForm.brandName().touched() &&
                            brandForm.brandName().invalid()) {
                            <ul class="error-list">
                                @for (error of brandForm.brandName().errors(); track error) {
                                <li class="text-error-light flex items-start gap-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                        <path
                                            d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                        <path d="M12 9v4" />
                                        <path d="M12 17h.01" />
                                    </svg>
                                    {{ error.message }}
                                </li>
                                }
                            </ul>
                            }
                        </div>

                        <div class="sm:col-span-6">
                            <label for="brandWebsiteInput" class="block text-sm/6 font-medium text-primary">Brand
                                website</label>
                            <div class="mt-2 flex">
                                <div
                                    class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-500 dark:text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 sm:text-sm/6">
                                    https://</div>
                                <input [formField]="brandForm.brandWebsite" #brandWebsiteInput id="agencyWebsiteInput"
                                    type="text" placeholder="www.example.com" autocomplete="url"
                                    class="input-url text-primary text-base rounded-r-md flex-1" />
                            </div>
                            @if (brandForm.brandWebsite().touched() &&
                            brandForm.brandWebsite().invalid()) {
                            <ul class="error-list">
                                @for (error of brandForm.brandWebsite().errors(); track error) {
                                <li class="text-error-light flex items-start gap-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                        <path
                                            d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                        <path d="M12 9v4" />
                                        <path d="M12 17h.01" />
                                    </svg>
                                    {{ error.message }}
                                </li>
                                }
                            </ul>
                            }
                        </div>

                        <div class="sm:col-span-6">
                            <label for="brandDescriptionInput" class="block text-sm/6 font-medium text-primary">Brand
                                description</label>
                            <div class="mt-2 px-2">
                                <textarea id="brandDescriptionInput" rows="4"
                                    placeholder="Write a few sentences about the brand..."
                                    [formField]="brandForm.brandDescription" class="input-textarea text-primary"></textarea>
                            </div>
                            @if (brandForm.brandDescription().touched() &&
                            brandForm.brandDescription().invalid()) {
                            <ul class="error-list">
                                @for (error of brandForm.brandDescription().errors(); track error) {
                                <li class="text-error-light flex items-start gap-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                        <path
                                            d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                        <path d="M12 9v4" />
                                        <path d="M12 17h.01" />
                                    </svg>
                                    {{ error.message }}
                                </li>
                                }
                            </ul>
                            }
                        </div>


                    </div>
                    } @else {
                    <div
                        class="mx-auto flex min-h-0 w-full max-w-4xl self-stretch flex-col gap-y-5 py-6 overflow-y-auto scrollbar-transparent">

                        <div class="w-full shrink-0">
                            <label for="brandDomainInput"
                                class="block text-sm/6 font-medium text-primary text-left">Your
                                website URL</label>
                            <div class="mt-2 flex flex-row items-center justify-start gap-x-2">
                                <div class="flex flex-1 flex-row justify-start">
                                    <div
                                        class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-500 dark:text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 sm:text-sm/6">
                                        https://</div>
                                    <input [formField]="brandFetchForm.domain" #brandDomainInput id="brandDomainInput"
                                        type="text" placeholder="www.example.com" autocomplete="url" role="combobox"
                                        aria-autocomplete="list"
                                        [attr.aria-expanded]="(brandSuggestions()?.length ?? 0) > 0"
                                        aria-controls="agency-brand-suggestions"
                                        class="input-url text-primary text-base rounded-r-md flex-1" />
                                </div>

                                <div class="flex flex-row items-center justify-start gap-x-2">
                                    <button type="button" (click)="resetBrandSearch()"
                                        class="secondary-button text-primary px-2 py-2 touch-manipulation rounded-md hover:text-primary">
                                        Clear search
                                    </button>
                                </div>
                            </div>


                        </div>

                        @if (brandSearchLoading()) {
                        <p class="w-full shrink-0 text-sm text-secondary" aria-live="polite">Searching for your brand…
                        </p>
                        }

                        @if (!brandSearchLoading() && brandSuggestions() !== undefined) {
                        <p class="sr-only w-full shrink-0" aria-live="polite" aria-atomic="true">
                            @if (brandSuggestions()!.length === 0) {
                            No matching brands found.
                            } @else {
                            {{ brandSuggestions()!.length }} brands found.
                            }
                        </p>
                        }

                        @if (brandSuggestions() && brandSuggestions()!.length > 0) {
                        <div id="agency-brand-suggestions"
                            class="grid min-h-0 w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" role="listbox"
                            aria-label="Brand search results">
                            @for (brand of brandSuggestions(); track brand.brandId) {
                            <div (click)="onBrandSelect(brand)" (keydown)="onBrandSuggestionKeydown($event, brand)"
                                role="option" tabindex="0"
                                class="relative flex min-w-0 items-center gap-3 rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 px-3 py-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary hover:border-gray-300 dark:hover:border-white/25 touch-manipulation cursor-pointer active:bg-gray-200 dark:active:bg-zinc-800/70 transition-colors duration-200 motion-reduce:transition-none">
                                <div class="shrink-0">
                                    <img [src]="brand.icon" [alt]="brand.name + ' logo'"
                                        class="size-10 rounded-full bg-gray-200 dark:bg-zinc-700 outline outline-1 -outline-offset-1 outline-gray-300 dark:outline-white/10" />
                                </div>
                                <div class="min-w-0 flex-1 flex flex-row items-center justify-between">
                                    <div class="text-left">
                                        <p class="text-sm font-medium text-primary">{{ brand.name }}</p>
                                        <p class="truncate text-sm text-secondary">{{ brand.domain }}</p>
                                    </div>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-secondary" aria-hidden="true">
                                        <path d="m9 18 6-6-6-6" />
                                    </svg>
                                </div>
                            </div>
                            }
                        </div>

                        } @else if (!brandSearchLoading() && brandSuggestions() !== undefined &&
                        brandSuggestions()!.length === 0) {
                        <div class="w-full shrink-0 flex flex-col gap-3 text-left">
                            <p class="text-sm/6 text-secondary max-w-xl">
                                We could not find a match for that website. Try another domain, clear your search, or
                                use
                                the Manual tab to enter details yourself.
                            </p>
                            <button type="button" (click)="selectedTab.set('manual')"
                                class="self-start text-sm font-semibold text-accent hover:text-primary/85 dark:hover:text-primary/85 px-3 py-2 touch-manipulation rounded-md">
                                Switch to Manual
                            </button>
                        </div>
                        }

                    </div>
                    }

                </div>

                <div class="shrink-0 z-10 w-full flex flex-row gap-x-4 p-2 justify-between card-container-pale">
                    <button (click)="closeBrandModal()" type="button" class="secondary-button">
                        Close
                    </button>

                    @if (savingBrand()) {
                    <span
                        class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                        <svg aria-hidden="true"
                            class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>

                        Saving Brand...
                    </span>
                    } @else {
                    <button (click)="saveBrand()" type="button"
                        class="primary-button inline-flex flex-row items-center gap-x-2 disabled:opacity-60 disabled:cursor-not-allowed">
                        Save Brand
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="M20 6 9 17l-5-5" />
                        </svg>
                    </button>
                    }
                </div>
            </div>


            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

        </div>
    </div>
</div>